import { render } from "./copytext.vue?vue&type=template&id=308600da&scoped=true"
import script from "./copytext.vue?vue&type=script&lang=js"
export * from "./copytext.vue?vue&type=script&lang=js"

import "./copytext.vue?vue&type=style&index=0&id=308600da&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-308600da"]])

export default __exports__